import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ProjectDetail from "@/pages/ProjectDetail";
import Wallet from "@/pages/Wallet";
import Registry from "@/pages/Registry";
import Marketplace from "@/pages/Marketplace";
import Ledger from "@/pages/Ledger";
import ComingSoon from "@/pages/ComingSoon";
import Justice from "@/pages/Justice";
import Commons from "@/pages/Commons";
import Tenders from "@/pages/Tenders";
import Passport from "@/pages/Passport";
import QualityPassport from "@/pages/QualityPassport";
import QualityScan from "@/pages/QualityScan";
import MemberDashboard from "@/pages/MemberDashboard";
import PickupConfirm from "@/pages/PickupConfirm";
import QualityLeaderboard from "@/pages/QualityLeaderboard";
import Architecture from "@/pages/Architecture";
import Pitch from "@/pages/Pitch";
import Twin from "@/pages/Twin";
import CreditVerify from "@/pages/CreditVerify";
import Renewal from "@/pages/Renewal";
import SocialHousing from "@/pages/SocialHousing";
import Campaign from "@/pages/Campaign";
import Field from "@/pages/Field";
import Health from "@/pages/Health";
import VisitCheckIn from "@/pages/VisitCheckIn";
import Referral from "@/pages/Referral";
import Mining from "@/pages/Mining";
import Micronutrients from "@/pages/Micronutrients";
import SeedVerify from "@/pages/SeedVerify";
import Offers from "@/pages/Offers";
import HubCount from "@/pages/HubCount";
import ShelterCheckin from "@/pages/ShelterCheckin";
import ReportVerify from "@/pages/ReportVerify";
import HousingVerify from "@/pages/HousingVerify";
import DigestVerify from "@/pages/DigestVerify";
import HubVote from "@/pages/HubVote";
import Soil from "@/pages/Soil";
import Disaster from "@/pages/Disaster";
import Dossier from "@/pages/Dossier";
import PublicAlertMap from "@/pages/PublicAlertMap";
import JevTuningReport from "@/pages/JevTuningReport";
import DemoAccess from "@/pages/DemoAccess";
import EdgeCompute from "@/pages/EdgeCompute";
import HousingMatrix from "@/pages/HousingMatrix";
import FundingRoom from "@/pages/FundingRoom";
import RaiseShare from "@/pages/RaiseShare";
import NoteVerify from "@/pages/NoteVerify";
import { LogoutDialog } from "@/components/LogoutDialog";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/registry" element={<Registry />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/ledger" element={<Ledger />} />
            <Route path="/justice" element={<Justice />} />
            <Route path="/commons" element={<Commons />} />
            <Route path="/tenders" element={<Tenders />} />
            <Route path="/passport/:lotId" element={<Passport />} />
            <Route path="/quality/scan" element={<QualityScan />} />
            <Route path="/quality/leaderboard" element={<QualityLeaderboard />} />
            <Route path="/architecture" element={<Architecture />} />
            <Route path="/pitch" element={<Pitch />} />
            <Route path="/twin" element={<Twin />} />
            <Route path="/credit/:id" element={<CreditVerify />} />
            <Route path="/pickup/:token" element={<PickupConfirm />} />
            <Route path="/count/:token" element={<HubCount />} />
            <Route path="/shelter/:token" element={<ShelterCheckin />} />
            <Route path="/vote/:token" element={<HubVote />} />
            <Route path="/soil" element={<Soil />} />
            <Route path="/alerts/map" element={<PublicAlertMap />} />
            <Route path="/jev/report" element={<JevTuningReport />} />
            <Route path="/disaster" element={<Disaster />} />
            <Route path="/dossier/:token" element={<Dossier />} />
            <Route path="/raise/:token" element={<RaiseShare />} />
            <Route path="/verify/report" element={<ReportVerify />} />
            <Route path="/verify/report/:code" element={<ReportVerify />} />
            <Route path="/verify/housing/:id" element={<HousingVerify />} />
            <Route path="/verify/note/:id" element={<NoteVerify />} />
            <Route path="/verify/:digest" element={<DigestVerify />} />
            <Route path="/quality/:batchId" element={<QualityPassport />} />
            <Route path="/commons/member" element={<ProtectedRoute><MemberDashboard /></ProtectedRoute>} />
            <Route path="/renewal" element={<Renewal />} />
            <Route path="/social-housing" element={<SocialHousing />} />
            <Route path="/campaign/:siteId" element={<Campaign />} />
            <Route path="/health" element={<Health />} />
            <Route path="/health/visits/:id" element={<VisitCheckIn />} />
            <Route path="/referral/:caseId/:token" element={<Referral />} />
            <Route path="/mining" element={<Mining />} />
            <Route path="/micronutrients" element={<Micronutrients />} />
            <Route path="/seed/:lotId/:token" element={<SeedVerify />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/coming-soon/:id" element={<ComingSoon />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/projects/:id" element={<ProtectedRoute><ProjectDetail /></ProtectedRoute>} />
            <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
            <Route path="/field" element={<ProtectedRoute><Field /></ProtectedRoute>} />
            <Route path="/edge" element={<EdgeCompute />} />
            <Route path="/housing" element={<HousingMatrix />} />
            <Route path="/funding" element={<ProtectedRoute><FundingRoom /></ProtectedRoute>} />
            <Route path="/demo/:token" element={<DemoAccess />} />
          </Routes>
          <LogoutDialog />
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
